import { render, staticRenderFns } from "./InvestorAnalytics.vue?vue&type=template&id=245a35e8"
import script from "./InvestorAnalytics.vue?vue&type=script&lang=js"
export * from "./InvestorAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports